import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import './pollyfills'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import store from './store'
import Auth from './auth'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar'
import i18n from './plugins/i18n'
import Dialogs from './plugins/dialogs'

Vue.config.productionTip = false

import './globalFilters.js'

// router setup
import routes from './routes/routes'

// library imports
import '@fortawesome/fontawesome-free/css/solid.css'
import '@fortawesome/fontawesome-free/css/regular.css'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import 'element-ui/packages/theme-chalk/src/index.scss'
import 'element-ui/lib/theme-chalk/display.css'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
// plugin setup
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify, { horizontalAlign: 'center', verticalAlign: 'top', timeout: 2000 })
Vue.use(Dialogs, { i18n })
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
Vue.use(VeeValidate)
locale.use(lang)

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

Vue.use(Auth, { router })

initProgress(router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  i18n,
  router,
  store
})
